export default __webpack_public_path__ + "static/media/facebook.b8bcc16c.svg";